import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import clsx from 'clsx';
import CustomButton from '../../../react-native-material-wrapper/button.component';
import { getTheme } from '../../../../stores/selectors/theme.selector';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { sharedStyles } from './shared-styles';
import { DoNotShowAgainCheckbox } from './do-not-show-again-checkbox';
import { useTranslation } from 'react-i18next';

export interface PopupProps {
  doNotShowAgainCheckbox: boolean;
  handleCheckboxChange: (checked: boolean) => void;
  handleClose: () => void;
  handleSmartChargingBtnClick: () => void;
  handleViewChargerBtnClick: () => void;
  open: boolean;
  checked: boolean;
}

const useSpecificStyles = makeStyles(() => ({
  dialogActionRoot: {
    padding: '0px 16px 0px 16px',
  },
}));

export const UnlicensedPopup = ({
  open,
  handleClose,
  handleSmartChargingBtnClick,
  handleViewChargerBtnClick,
  checked,
  handleCheckboxChange,
  doNotShowAgainCheckbox,
}: PopupProps) => {
  const { t } = useTranslation();
  const theme = useSelector(getTheme);
  const specificClasses = useSpecificStyles();
  const sharedClasses = sharedStyles({
    dialogActionRoot: {
      padding: '0px 16px 0px 16px',
    },
  });
  const classes = {
    ...sharedClasses,
    ...specificClasses,
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{
        container: classes.container,
        paper: classes.paper,
      }}
    >
      <DialogTitle
        classes={{
          root: clsx(classes.title, classes.XPadding),
        }}
      >
        {t('unlicensed_charger_popup_heading_1')}
        <DialogContent classes={{ root: classes.content }}>
          <DialogContentText id='dialog-description-1' classes={{ root: classes.contentTextRoot }}>
            {t('unlicensed_charger_popup_content_1')}
          </DialogContentText>
        </DialogContent>
      </DialogTitle>
      <DialogActions classes={{ root: classes.dialogActionRoot }}>
        <CustomButton
          variant='contained'
          className={classes.buttonStyles}
          style={{
            backgroundColor: theme.brand_2,
            color: '#ffffff',
          }}
          onClick={handleSmartChargingBtnClick}
          disabled={false}
          disableElevation
        >
          {t('unlicensed_charger_popup_btn_1')}
        </CustomButton>
      </DialogActions>
      <DialogTitle
        classes={{
          root: clsx(classes.title, classes.XPadding),
        }}
      >
        {t('unlicensed_charger_popup_heading_2')}
        <DialogContent classes={{ root: classes.content }}>
          <DialogContentText id='dialog-description-2' classes={{ root: classes.contentTextRoot }}>
            {t('unlicensed_charger_popup_content_2')}
          </DialogContentText>
        </DialogContent>
      </DialogTitle>
      <DialogActions
        classes={{
          root: classes.dialogActionRoot,
        }}
      >
        <CustomButton
          variant='contained'
          className={classes.buttonStyles}
          style={{
            backgroundColor: theme.brand_0,
            color: theme.brand_2,
          }}
          onClick={handleViewChargerBtnClick}
          disabled={false}
          disableElevation
        >
          {t('unlicensed_charger_popup_btn_2')}
        </CustomButton>
      </DialogActions>
      {doNotShowAgainCheckbox && (
        <DoNotShowAgainCheckbox checked={checked} handleCheckboxChange={handleCheckboxChange} />
      )}
    </Dialog>
  );
};
